/**
 * Type guard to check if an error is a backend error with specific structure
 */
export function isBackendError(error: unknown): error is {
  response: {
    data: {
      code: string;
      details: Array<{ field: string; message: string }>;
    };
  };
} {
  return (
    typeof error === "object" &&
    error !== null &&
    "response" in error &&
    typeof error.response === "object" &&
    error.response !== null &&
    "data" in error.response &&
    typeof error.response.data === "object" &&
    error.response.data !== null &&
    "code" in error.response.data &&
    "details" in error.response.data &&
    Array.isArray(error.response.data.details)
  );
}

/**
 * Extract a user-friendly error message from various error types
 */
export function getErrorMessage(error: unknown, defaultMessage = "An unexpected error occurred"): string {
  // Check for a structured backend error FIRST. An AxiosError is also an
  // `instanceof Error`, so checking Error before the backend shape would swallow
  // the field-specific validation messages and surface a generic "422"/network
  // message to staff instead.
  if (isBackendError(error)) {
    // If there are field-specific errors, return the first one
    if (error.response.data.details.length > 0) {
      return error.response.data.details[0].message;
    }
    // Otherwise return the error code
    return error.response.data.code;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  return defaultMessage;
}